import { Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import DotsBackground from "../components/DotsBackground.tsx";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col relative">
      <DotsBackground />
      {/* Header */}
      <header className="flex items-center px-8 py-6 relative z-10">
        <div className="flex items-center gap-2">
          <img
            src="../assets/aksa-icon-square.png"
            alt="Aksa Icon"
            className="w-8 h-8"
          />
          <span
            className="text-2xl font-bold tracking-tight"
            style={{ fontFamily: "Feather Bold" }}
          >
            <span style={{ color: "#1A365D" }}>Galaxy</span>{" "}
            <span style={{ color: "#EF4444" }}>Aksara</span>
          </span>
        </div>
      </header>

      {/* Main Content */}
      <main className="mx-auto flex w-full max-w-[988px] flex-1 flex-col items-center justify-center gap-2 p-4 lg:flex-row-reverse relative z-10">
        <div className="relative mb-8 h-[240px] w-[240px] lg:mb-0 lg:h-[424px] lg:w-[424px]">
          <img
            src="/assets/hero.png"
            alt="hero"
            className="w-full h-full object-contain"
            draggable={false}
          />
        </div>
        <div className="flex flex-col items-center">
          <h1
            className="max-w-[500px] text-center text-xl font-bold text-gray-800 lg:text-3xl mb-2"
            style={{ fontFamily: "Feather Bold" }}
          >
            Belajar Bahasa Batak <br /> Seru dan Interaktif bareng Aksa!
          </h1>
          <h2
            className="max-w-[480px] text-center text-xl font-bold text-gray-800 lg:text-3xl mb-4"
            style={{ fontFamily: "Noto Sans Batak" }}
          >
            ᯔᯔᯮᯰᯄ ᯂᯖ ᯅᯖᯄ᯲, ᯂᯬᯒᯘ᯲ ᯑᯬᯂᯬᯖ᯲ ᯔᯒ᯲ᯘᯄᯬᯞ ᯐᯞ ᯔᯒ᯲ᯘᯞᯩᯉ᯲ᯑᯰ ᯖᯮ ᯀᯄ᯲ᯘ!
          </h2>
          <div className="flex w-full max-w-[330px] flex-col items-center gap-y-3">
            <Link
              to="/register"
              className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-white font-bold py-4 px-8 rounded-xl text-center transition-all duration-200 transform hover:scale-105 active:translate-y-0"
              style={{ fontFamily: "Feather Bold" }}
            >
              Yuk, Mulai!
            </Link>
          </div>
        </div>
      </main>
      {/* Footer */}
      <footer className="w-full py-6 mt-8 bg-transparent flex flex-col items-center gap-2 z-10 relative">
        <div className="text-gray-500 text-sm font-semibold">
          &copy; {new Date().getFullYear()} Galaxy Developer
        </div>
        <div className="flex gap-4 mt-1">
          <a
            href="https://www.instagram.com/galaxy.developer/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 text-gray-500 hover:text-pink-500 transition font-semibold text-sm"
          >
            <Instagram className="text-lg" />
          </a>
          <a
            href="https://www.linkedin.com/company/galaxydeveloper"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 text-gray-500 hover:text-blue-700 transition font-semibold text-sm"
          >
            <Linkedin className="text-lg" />
          </a>
        </div>
      </footer>
    </div>
  );
}
